import { crudRequest } from '@/services/api';
import { getCommon } from '@/components/report/service';
import { CALCWEIGHT, Aggregator } from '@/models/GenerateCondit/Interrelated';
import { loadingRateGoodsQuery, loadingRateVolumeQuery } from '../Sql/Modals';
import moment from 'moment';

const params = {};
export default {
  namespace: 'loadingrateboard',
  state: {
    onSearch: false,
    startDate: '',
    endDate: '',
    transportLineType: '',
  },

  effects: {
    *getData({ payload }, { call, put, select }) {
      return;
    },

    /**
     * 获取周累计值
     */
    *getWeekSumData(_, { call, put, select }) {
      let query = yield select(({ loadingrateboard }) => {
        return {
          startDate: loadingrateboard.startDate,
          endDate: loadingrateboard.endDate,
          transportLineType: loadingrateboard.transportLineType,
        };
      });
      const filter = loadingRateGoodsQuery(query);
      const params = {
        aggregators: [CALCWEIGHT],
      };
      const data = yield call(getCommon, { ...params, ...filter });

      const filter1 = loadingRateVolumeQuery(query);
      const params1 = {
        aggregators: [new Aggregator('doubleSum', 'actualCapacity', 'actualCapacity')],
      };
      const data1 = yield call(getCommon, { ...params1, ...filter1 });

      const items = [];
      data &&
        data.forEach(item => {
          const goodsWeight = item.goodsWeight ? (Math.abs(item.goodsWeight) / 1000).toFixed(2) : 0;
          items.push({
            name: moment(item.timestamp).format('YYYY-MM-DD'),
            value: goodsWeight,
          });
        });
      yield put({
        type: 'update',
        payload: {
          modalData2: items,
        },
      });
    },

    /**
     * 获取单日值
     */
    *getDaySumData(_, { call, put, select }) {
      //   let centerFilter = yield select(
      //     ({ loadingrateboard }) => loadingrateboard.searchParams.centerFilter,
      //   );
      let query = yield select(({ loadingrateboard }) => {
        return {
          // title: loadingrateboard.modalTitle,
          startDate: loadingrateboard.startDate,
          endDate: loadingrateboard.endDate,
          transportLineType: loadingrateboard.transportLineType,
          // nextProvinceArea: loadingrateboard.modalFiller?.nextProvinceArea,
        };
      });
      const filter = loadingRateGoodsQuery(query);
      const params = {
        aggregators: [CALCWEIGHT, new Aggregator('doubleSum', 'actualCapacity', 'actualCapacity')],
      };
      //   const data = yield call(getTimestampData, { ...params, ...filter[1] });
      const data = yield call(getCommon, { ...params, ...filter });
      const items = [];
      data &&
        data.forEach(item => {
          const goodsWeight = item.goodsWeight ? (Math.abs(item.goodsWeight) / 1000).toFixed(2) : 0;
          items.push({
            name: moment(item.timestamp).format('YYYY-MM-DD'),
            value: goodsWeight,
          });
        });
      yield put({
        type: 'update',
        payload: {
          modalData2: items,
        },
      });
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
